











import Vue from 'vue'
import dayjs from 'dayjs'
import { DATE_TIME_FORMAT } from '@/const'
import EventEntity from '@/entities/Event'

export default Vue.extend({
  props: {
    eventData: {
      type: Object as () => EventEntity,
      required: true
    },
    today: {
      type: String,
      default: ''
    }
    // TODO:再掲載無しの判定方法調べる。一旦仮です。
  },
  computed: {
    setPeriod(): string {
      // TODO: サーバーから返ってきたデータを使用する
      if (!this.today) return ''
      const today = dayjs(this.today, DATE_TIME_FORMAT).format('YYYY-MM-DD 00:00:00.000000')
      if (this.eventData.getRemainingDays(today) < 0) {
        return ''
      } else if (this.eventData.getRemainingDays(today) === 0) {
        return '本日まで'
      } else {
        return 'あと' + this.eventData.getRemainingDays(today) + '日'
      }
    },
    setEndDate(): string {
      return '(' + dayjs(this.eventData.props.orderEndDt, DATE_TIME_FORMAT).format('YYYY/MM/DD') + ' 24:00まで)'
    }
  }
})
